import React from "react";

interface FormFieldsetProps {
    number?: number;
    title?: string;
    className?: string;
    children: React.ReactNode;
}

export default function FormFieldsetComponent({number, title, className, children}: FormFieldsetProps) {
    return <fieldset className={className}>
        {title && (
            <legend>
                <h3 className={'heading heading--montserrat heading--big heading--left'}>
                    {number && <span className={'number'}>{number}.{' '}</span>}
                    <span className={'text'}>{title}</span>
                </h3>
            </legend>
        )}
        {children}
    </fieldset>
}
